<template>
  <widget-dropdown
    v-model="show"
    class="widget-emoji-dropdown"
    :content-class="'widget-emoji-dropdown__content'"
    :position="openPosition"
    :close-on-content-click="false"
    fit
  >
    <slot>
      <widget-button
        is-icon-only
        color="secondary"
        size="28"
        view="transparent"
        :is-disabled="disabled"
        :tabindex="tabindex"
      >
        <widget-icon
          name="tmi-emoticon-outline"
          size="20px"
        />
      </widget-button>
    </slot>

    <template v-slot:menu>
      <widget-emoji-picker
        @select="onSelectEmoji($event)"
        @emoji-loaded="emojiDataLoaded = true"
      />

      <widget-dropdown-item v-if="!emojiDataLoaded">
        <div class="d-flex justify-between align-center">
          <div
            v-for="i in 5"
            :key="i"
          >
            <widget-skeleton
              v-for="j in 5"
              :key="j"
              type="circle"
              width="20px"
              height="20px"
              animation="wave"
              class="ml-1 mb-1 mt-1 mr-1"
            />
          </div>
        </div>
      </widget-dropdown-item>
    </template>
  </widget-dropdown>
</template>

<script lang="ts" setup>
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import WidgetDropdown from '@widgets/shared/components/dropdown/WidgetDropdown.vue'
import WidgetDropdownItem from '@widgets/shared/components/dropdown/WidgetDropdownItem.vue'
import WidgetEmojiPicker from '@widgets/shared/components/WidgetEmojiPicker.vue'
import WidgetSkeleton from '@widgets/shared/components/WidgetSkeleton.vue'
import WidgetButton from '@widgets/shared/components/WidgetButton.vue'
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import type { ControlPosition } from '@/composition/tooltip/renderTooltip'
import { ref, watch, computed } from '@/composition/vue/compositionApi'

import type { Emoji } from '@/services/forms/tmTiptap/types'

const props = withDefaults(
  defineProps<{
    modelValue?: boolean
    hideAfterSelect?: boolean
    disabled?: boolean
    tabindex?: string
    isBottomOpen?: boolean
  }>(),
  {
    hideAfterSelect: true,
  },
)

const emit = defineEmits<{
  (e: 'select-emoji', emoji: Emoji): void
  (e: 'update:model-value', val: boolean): void
}>()

const show = ref(props.modelValue)
const emojiDataLoaded = ref(false)
const openPosition = computed<ControlPosition>(() => (props.isBottomOpen ? 'bottom-right' : 'top-right'))

const onSelectEmoji = (emoji: Emoji): void => {
  show.value = !props.hideAfterSelect
  emit('select-emoji', emoji)
  emit('update:model-value', show.value)
}

watch(
  () => props.modelValue,
  () => {
    show.value = props.modelValue
  },
)
</script>

<style lang="scss" scoped>
.widget-emoji-dropdown {
  &__icon {
    padding: 0 14px;
  }
}
</style>
